import { api } from './api';

export interface SubscriptionDetails {
  subscription: {
    plan: string;
    status: string;
    period: string | null;
    expires_at: string | null;
    remaining_days: number | null;
    next_billing_at: string | null;
  };
  razorpay_subscription?: {
    id: string;
    status: string;
    plan_name: string;
    period: string;
    amount: number;
    current_start: string | null;
    current_end: string | null;
    next_charge_at: string | null;
  } | null;
}

export interface CreateSubscriptionResponse {
  success: boolean;
  subscription: {
    id: string;
    status: string;
    plan_id: string;
    auth_link: string | null;
    plan: string;
    period: string;
  };
  key_id: string;
}

export interface SubscriptionOperationResponse {
  success: boolean;
  message: string;
  subscription?: any;
}

/**
 * Create a new Razorpay subscription
 */
export const createSubscription = async (
  plan: 'basic' | 'premium',
  period: 'monthly' | 'yearly'
): Promise<CreateSubscriptionResponse> => {
  const response = await api.post<CreateSubscriptionResponse>('/payments/create-subscription', {
    plan,
    period
  });
  return response.data;
};

/**
 * Authorize mandate for subscription
 */
export const authorizeMandate = async (data: {
  razorpay_subscription_id: string;
  razorpay_payment_id: string;
  razorpay_signature?: string;
}): Promise<SubscriptionOperationResponse> => {
  const response = await api.post<SubscriptionOperationResponse>('/payments/authorize-mandate', data);
  return response.data;
};

/**
 * Verify subscription activation
 */
export const verifySubscription = async (subscriptionId: string): Promise<SubscriptionOperationResponse> => {
  const response = await api.post<SubscriptionOperationResponse>('/payments/verify-subscription', {
    razorpay_subscription_id: subscriptionId
  });
  return response.data;
};

/**
 * Get subscription details including Razorpay subscription info
 */
export const getSubscriptionDetails = async (): Promise<SubscriptionDetails> => {
  const response = await api.get<SubscriptionDetails>('/subscriptions/details');
  return response.data;
};

/**
 * Cancel active subscription
 */
export const cancelSubscription = async (): Promise<SubscriptionOperationResponse> => {
  const response = await api.post<SubscriptionOperationResponse>('/subscriptions/cancel');
  return response.data;
};

/**
 * Pause active subscription
 */
/*
export const pauseSubscription = async (): Promise<SubscriptionOperationResponse> => {
  const response = await api.post<SubscriptionOperationResponse>('/subscriptions/pause');
  return response.data;
};
*/

/**
 * Resume paused subscription
 */
export const resumeSubscription = async (): Promise<SubscriptionOperationResponse> => {
  const response = await api.post<SubscriptionOperationResponse>('/subscriptions/resume');
  return response.data;
};



